import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  height: "48",
  width: "48",
  class: "yb-svg-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M12 9C17.5228 9 22 6.98528 22 4.5C22 2.01472 17.5228 0 12 0C6.47715 0 2 2.01472 2 4.5C2 6.98528 6.47715 9 12 9ZM12 19C6.5 19 2 17 2 14.5V19.5C2 22 6.5 24 12 24C17.5 24 22 22 22 19.5V14.5C22 17 17.5 19 12 19ZM2 7C2 9.5 6.5 11.5 12 11.5C17.5 11.5 22 9.5 22 7V12C22 14.5 17.5 16.5 12 16.5C6.5 16.5 2 14.5 2 12V7Z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }